import styled from 'styled-components';

export const RulesContainerStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SidePanelContainer = styled.div`
  block-size: inherit;
  inline-size: 5%;
  max-inline-size: 4.5rem;
  min-inline-size: 5.5rem;
`;
